<p-select [options]="values" [(ngModel)]="selectedValue" placeholder="Select"></p-select>